import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom'; // uses browser's history API to create real URLs
import config from './config';

ReactDOM.render(
  <Router>
    <App 
    apiKey={config.API_KEY}
    sessionId={config.SESSION_ID}
    token={config.TOKEN}/>
  </Router>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
